import { ESPNVSPlayerVSPlayerConfig } from '../../../../../../types/banner/clients/DISNEY/creativity-configs';

export const cleanFormData = (formData: any): ESPNVSPlayerVSPlayerConfig => {
  const { league, team1, player1, team2, player2 } = formData;

  return {
    league,
    team1,
    player1,
    team2,
    player2
  };
};
